import React from 'react';
import { ButtonLaunchingPopover } from 'acscp/components/common/buttonLaunchingPopover';
import { FormattedMessage } from 'react-intl';
import style from 'acscp/components/loyalty/basketButton.module.scss';
import { BasketPage } from 'acscp/components/loyalty/basketPage';
import { AppState } from 'acscp/store';
import { getTotalNumberOfValidGiftsInBasket } from 'acscp/store/helpers/basketHelper';
import { connect } from 'react-redux';

interface BasketButtonOwnProps {
    openOnAddingGift: boolean;
}
interface BasketButtonStateProps {
    basketCount: number;
}

export class BasketButtonPresentational extends React.Component<
    BasketButtonOwnProps
    & BasketButtonStateProps, {}> {
    private buttonLaunchingPopover: ButtonLaunchingPopover | null;

    componentWillReceiveProps(nextProps: Readonly<BasketButtonOwnProps & BasketButtonStateProps>, nextContext: any): void {
        if (nextProps.openOnAddingGift && nextProps.basketCount > this.props.basketCount) {
            this.showBasket();
        }
    }

    render(): JSX.Element {
        return (
            <ButtonLaunchingPopover
                buttonClassName={style.BasketButton}
                childComponentFactory={closePopover => <BasketPage closeSelf={closePopover} />}
                popoverBodyClassName={style.BasketPopover}
                ref={b => this.buttonLaunchingPopover = b}
            >
                <FormattedMessage
                    id={'components.gifts.loyaltyPage.basketButton'}
                    defaultMessage={'Basket ({itemCount})'}
                    values={{ itemCount: this.props.basketCount }}
                />
            </ButtonLaunchingPopover>
        );
    }

    private showBasket: () => void = () => {
        if (!this.buttonLaunchingPopover) {
            return;
        }

        this.buttonLaunchingPopover.openPopover();
    }
}

function mapStateToProps(state: AppState): BasketButtonStateProps {
    return {
        basketCount: getTotalNumberOfValidGiftsInBasket(state.gifts)
    };
}

export const BasketButton = connect(mapStateToProps)(BasketButtonPresentational);
